export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/joshua-earles-5af0b5e8016fee5b0627e4c778dfe400.jpg";